import { Card, Col, Input, Row, Select, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { getFreelancers, IFreelancersRes } from "api/freelancers";
import DescriptionText from "components/DescriptionText";
import { GhostBtn } from "components/GhostBtn";
import IconCaretDown from "components/Icon/CaretDown";
import IconEdit from "components/Icon/Edit";
import IconSearch from "components/Icon/Search";
import MainTitle from "components/MainTitle";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import FreelanceAction from "./FreelanceAction";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import moment from "moment";

const Freelancers = () => {
  const { t } = useTranslation("translation");
  const [visible, setvisible] = useState(false);
  const [isAscending, setisAscending] = useState<string>("undefined");
  const [keyword, setkeyword] = useState<string>();
  const [actionRecord, setactionRecord] = useState<IFreelancersRes>();

  const { data, mutate } = useMutation("get-freelancers", getFreelancers);

  const freelancerTableColumns: ColumnsType<any> = [
    {
      key: "Name",
      title: t("Name_name"),
      dataIndex: "name",
      render: (_, row) => {
        return (
          <Link to={`/freelancers/${row?.id}`} style={{ color: "#cc00ff" }}>
            {row?.name}
          </Link>
        );
      },
    },
    {
      key: "Occupation",
      title: t("Occupation_occupation__1"),
      dataIndex: "occupation",
      render: (text) => text,
    },
    {
      key: "Email",
      title: t("Email_email"),
      dataIndex: "email",
      render: (_, row) => {
        return <a href={"mailto:" + row?.email}>{row?.email}</a>;
      },
    },
    {
      key: "Location",
      title: t("Location_location__2"),
      dataIndex: "location",
      render: (text) => text,
    },
    {
      key: "Phone",
      title: t("Phone_phone"),
      dataIndex: "phone",
      render: (text) => text,
    },
    {
      key: "Created Date",
      title: t("Created_Date"),
      dataIndex: "createdAt",
      render: (text) => moment.utc(text).local().format("YYYY-MM-DD"),
    },
    {
      key: "Action",
      title: t("Action_action"),
      render: (record) => (
        <GhostBtn
          onClick={() => {
            setvisible(true);
            setactionRecord(record);
          }}>
          <IconEdit />
        </GhostBtn>
      ),
    },
  ];

  const getAscendingValue = (value: string) => {
    if (value === "undefined") return undefined;
    if (value === "true") return true;
    if (value === "false") return false;
  };

  const onSearch = debounce((ev) => setkeyword(ev.target.value), 550);

  const handleSuccess = () => {
    setactionRecord(undefined);
    mutate({ isAscending: getAscendingValue(isAscending), keyword });
    setvisible(false);
  };

  useEffect(() => {
    const sortValue = getAscendingValue(isAscending);
    mutate({ isAscending: sortValue, keyword: keyword });
    // eslint-disable-next-line
  }, [isAscending, keyword]);

  return (
    <>
      <MainTitle title={t("Freelancer_freelancer")} />
      <DescriptionText text={t("All_here")} />
      <br />
      <br />
      <Card>
        <Row align="middle" gutter={12}>
          <Col>{t("Sort_by")}:</Col>
          <Col>
            <Select
              style={{ width: 120 }}
              defaultValue={isAscending}
              suffixIcon={<IconCaretDown />}
              onChange={(val: any) => setisAscending(val)}>
              <Select.Option value={"undefined"}>{t("Default")}</Select.Option>
              <Select.Option value={"true"}>{t("Ascending")}</Select.Option>
              <Select.Option value={"false"}>{t("Descending")}</Select.Option>
            </Select>
          </Col>
          <Col>
            <Input
              prefix={<IconSearch />}
              placeholder={t("search_search")}
              onChange={onSearch}
            />
          </Col>
        </Row>
        <br />
        <Table
          rowKey={(prop) => prop.id}
          pagination={{
            pageSize: 10,
          }}
          columns={freelancerTableColumns}
          dataSource={data}
          scroll={{ x: 1200 }}
        />
      </Card>
      <FreelanceAction
        handleSuccess={handleSuccess}
        actionRecord={actionRecord}
        visible={visible}
        onCancel={() => setvisible(false)}
      />
    </>
  );
};

export default React.memo(Freelancers);
